"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _errorTypes = _interopRequireDefault(require("./lib/errorTypes"));

var _default = function _default() {
  return {
    initialState: {
      loading: false,
      error: {
        message: "",
        type: _errorTypes["default"].none
      },
      data: []
    },
    defaultSwitchCases: function defaultSwitchCases(_ref) {
      var state = _ref.state,
          action = _ref.action,
          types = _ref.types,
          initialState = _ref.initialState;

      switch (action.type) {
        case types.RESET_STORE:
          return initialState;

        case types.UPDATE_LOADING:
          return (0, _extends2["default"])({}, state, {
            loading: !!action.payload
          });

        case types.UPDATE_ERROR:
          if (!action.payload) {
            return (0, _extends2["default"])({}, state, {
              error: {
                message: "",
                type: _errorTypes["default"].none
              }
            });
          }

          return (0, _extends2["default"])({}, state, {
            error: {
              message: action.payload.message,
              type: _errorTypes["default"][action.payload.type] || _errorTypes["default"].unknown
            }
          });

        case types.UPDATE_DATA:
          return (0, _extends2["default"])({}, state, {
            data: action.payload
          });

        default:
          return state;
      }
    }
  };
};

exports["default"] = _default;